import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import ShippingForm from './ShippingForm';
import CardHeader from 'react/shared/components/true_link/lab/form/wizard/CardHeader';
import NextPageButton from 'react/shared/components/true_link/lab/form/wizard/NextPageButton';
import { possessiverize } from 'react/shared/utils/Strings';
import schema from 'react/shared/utils/schemas';
import WizardCard from 'react/signups/card/common/WizardCard';
import addressShape from 'react/signups/card/shapes/AddressShape';
import cardAccountSignupShape from 'react/signups/card/shapes/CardAccountSignup';
import shippingDataShape from 'react/signups/card/shapes/ShippingData';

export default function Shipping({
  cardAccountSignup,
  cardholderAddress,
  firstName,
  moduleComplete,
  organizationAddress,
  setShippingData,
  shippingData,
}) {
  const validationSchema = Yup.object().shape({
    shippingDestination: Yup.string().required('Please select one of the options'),
    address: Yup.object().when('shippingDestination', {
      is: 'other',
      then: () => schema.address.required(),
    }),
  });

  const handleContinue = (values) => {
    setShippingData({
      shippingDestination: values.shippingDestination,
      otherAddress: {
        street1: values.shippingDestination === 'other' ? values.address.street1 : '',
        street2: values.shippingDestination === 'other' ? values.address.street2 : '',
        city: values.shippingDestination === 'other' ? values.address.city : '',
        state: values.shippingDestination === 'other' ? values.address.state : '',
        zip: values.shippingDestination === 'other' ? values.address.zip : '',
      },
    });
  };

  const initialValues = {
    shippingDestination: shippingData.shippingDestination,
    address: shippingData.otherAddress,
  };

  return (
    <WizardCard>
      <CardHeader>Where do you want {possessiverize(firstName)} card shipped?</CardHeader>
      <Formik
        initialValues={initialValues}
        onSubmit={handleContinue}
        validationSchema={validationSchema}
      >
        {({ handleSubmit, setValues, values, handleChange, setFieldTouched }) => (
          <>
            <ShippingForm
              cardAccountSignupShippingEstimate={cardAccountSignup.shippingEstimate || ''}
              cardholderAddress={cardholderAddress}
              cardholderFirstName={firstName}
              onChange={handleChange}
              organizationAddress={organizationAddress}
              setFieldTouched={setFieldTouched}
              setValues={setValues}
              values={values}
            />
            <NextPageButton disabled={moduleComplete} onClick={handleSubmit} />
          </>
        )}
      </Formik>
    </WizardCard>
  );
}

Shipping.propTypes = {
  cardAccountSignup: cardAccountSignupShape.isRequired,
  cardholderAddress: addressShape.isRequired,
  firstName: PropTypes.string.isRequired,
  moduleComplete: PropTypes.bool.isRequired,
  organizationAddress: addressShape.isRequired,
  setShippingData: PropTypes.func.isRequired,
  shippingData: shippingDataShape,
};
